import { createSlice } from "@reduxjs/toolkit";
import { lensProp, pathOr, pipe, set } from "ramda";
import * as AppActions from "./actions";

export const initialState = {
  apiErrorStatusCode: null,
  apiError: null,
  remainingCredits: null,
};

const appSlice = createSlice({
  name: "App",
  initialState,
  reducers: {},
  extraReducers: {
    [AppActions.resetAppState.type]: (state, action) => {
      return initialState;
    },
    [AppActions.setApiError.type]: (state, action) => {
      return pipe(
        set(lensProp("apiError"), pathOr(null, ["payload", "value"], action))
      )(state);
    },
    [AppActions.setRemainingCredits.type]: (state, action) => {
      return pipe(
        set(lensProp("remainingCredits"), pathOr(null, ["payload", "value"], action))
      )(state);
    },
  },
});

export const { actions, reducer, name: sliceKey } = appSlice;
